module.exports = __webpack_public_path__ + "static/media/affordabilityChart.e50cd3e8.png";